'use client';

import { Fragment } from 'react';
import Hero from '@/components/Hero';
import VideoTextCard from '@/components/VideoTextCard';
import card1Data from '../../../textContent/agriculture/card1Data.json';
import card2Data from '../../../textContent/agriculture/card2Data.json';
import { motion } from 'framer-motion';
/* ---------------- Animation Variants ---------------- */

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut',
        },
    },
};

const page = () => {
    const heroTextContent = {
        heading: 'Monitor Resources, and Cultivate Maximum Yield',
        caption:
            'ERPNext streamlines all your farm operations, from planting schedules to livestock management, automating tasks and boosting productivity.',
        image: '/images/hero/accounts.png',
        buttonText: 'Contact Sales',
        buttonLink: '/contact-sales',
    };

    return (
        <Fragment>
            {/* Hero Animation */}
            <motion.div variants={fadeUp} initial="hidden" animate="visible">
                <Hero {...heroTextContent} />
            </motion.div>

            {/* Card 1 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={card1Data} />
            </motion.div>

            {/* Card 2 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={card2Data} />
            </motion.div>
        </Fragment>
    );
};

export default page;
